import type { VersionStackAsset } from '@frameio/graphql-client/generated';
import type { SupportedTypes } from '../types';

/**
 * Type guard for Version Stacks.
 *
 * @returns boolean, true if asset is VersionStackAsset
 */
export const isVersionStack = (
  item: SupportedTypes
): item is VersionStackAsset =>
  item !== undefined &&
  item !== null &&
  'versions' in item &&
  item.__typename === 'VersionStackAsset';
